module.exports = __webpack_public_path__ + "static/Q1_2022_Investor_call-f3d1c402ccd0d248003c8bd94ae04cae.pdf";